import { createFileRoute, Navigate, Outlet, redirect } from "@tanstack/react-router";
import { Spinner } from "@timeghost/ui/shadcn/spinner";
import type { JSX } from "react";
import { isPlatformAdmin } from "@/lib/permissions/is-platform-admin";
import stores from "@/lib/stores";

type AdminGate = "pending" | "allow" | "deny";

const AdminLayout = (): JSX.Element => {
	const gate = stores.user.useStore((state): AdminGate => {
		if (!state.value) {
			return "pending";
		}
		return isPlatformAdmin(state.value) ? "allow" : "deny";
	});
	if (gate === "deny") {
		return <Navigate to="/timer" />;
	}
	if (gate === "pending") {
		return (
			<div className="flex min-h-0 flex-1 items-center justify-center p-8">
				<Spinner className="text-muted-foreground" size="sm" />
			</div>
		);
	}
	return <Outlet />;
};

export const Route = createFileRoute("/_app/admin")({
	beforeLoad: () => {
		const user = stores.user.useStore.getState().value;
		if (user && !isPlatformAdmin(user)) {
			throw redirect({ to: "/timer" });
		}
	},
	component: AdminLayout,
});
